import { HttpStatus } from 'src/shared/constants/httpStatus';
import { ApiError } from './error';
const whenGenericError = (error) => {
    const genericError = new ApiError({
        message: error?.message,
        statusCode: HttpStatus.InternalServerError
    });
    return Promise.reject(genericError);
};
export function whenRequestWithError(error) {
    if (error.request) {
        const requestError = new ApiError({
            statusCode: Number(error.code),
            message: error.request.toString()
        });
        return Promise.reject(requestError);
    }
    return whenGenericError(error);
}
export function whenResponseWithError(error) {
    if (error.response) {
        const { message, ...extra } = error.response.data ?? {};
        const responseError = new ApiError({
            headers: error.response.headers,
            statusCode: error.response.status,
            extra,
            message: message ?? ''
        });
        return Promise.reject(responseError);
    }
    return whenGenericError(error);
}
